import { BonusSettings } from "../../../api/bonus.types";
import { BonusSettingsAction } from "./bonus.settings.types";

export const bonusSettingsRequestAction = (): BonusSettingsAction => ({ type: 'BONUS_SETTINGS_REQUEST' })

export const bonusSettingsSuccessAction = (settings: BonusSettings): BonusSettingsAction => ({ type: 'BONUS_SETTINGS_SUCCESS', params: settings })

export const bonusSettingsFailureAction = (error?: any) => ({ type: 'BONUS_SETTINGS_FAILURE' } as const)